module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAABHNCSVQICAgIfAhkiAAAAQxJREFUSInVlcGOgjAQhv82G7wInAQjlez7P8IezMZ4MdHXUHwBpiZNZw9KTcwWoYCJ/4VDJ3zTf/gHwcyMCSWnfPl7AfvDEaeqgrV2VIBoZvCz+QUAzKIIqlhBFSvMomh8gDsQAss8Q1kUSNMkGPDlO2BmnKsLztUFaRKjVAp5toCU/cbmvcF/CrGvF6CRlBJ5tsD3eo04nrfWei1qk7W2s33uBsYY1ESoiaBJoyYC6dtT6yteBd5nn+iyKpgZWl8fDdzBdG/EGONqn+2bLMmWb4F1M5jKIgfYbHdBnb4actBX1PhcKoU0iVtrewFCgtYJMGRVeAHOhrGX3djr2gGG2NCmTkkeos//6f8Ba1miTReHmSgAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/send_disabled.png
// module id = 5cot
// module chunks = 2